export const BORDER_DEFAULT = '#EBEBEB';
export const BORDER_SUBTLE = '#E0E0E0';
export const TEXT_DEFAULT = 'rgba(26, 22, 23, 0.92)';
export const TEXT_MUTED = 'rgba(26, 22, 23, 0.6)';
export const RATE_BELOW = '#27AE60';
export const RATE_ABOVE = '#B00020';
export const ACCENT_BLUE = '#2563EB';
export const DOT_COMPLETE = '#BDBDBD';
export const CODE_BLOCK_BACKGROUND_LIGHT = '#E8E8E8';
export const CODE_BLOCK_BACKGROUND_DARK = '#313131';
export const CODE_BLOCK_BORDER_LIGHT = '#808080';
export const CODE_BLOCK_BORDER_DARK = '#707070';
